




document.addEventListener("DOMContentLoaded", function () {
      var swiper = new Swiper(".uannocmentslider", {
        loop: true, 
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 
        },
        speed: 1000,
      });
    });



initslide();

$(document).on('shopify:section:load', function(event) {
  initslide();
});
$(document).on('shopify:section:unload', function(event) {
  $('.u-testim-slider').slick('unslick');
});
function initTestimonialSlider() {
    $('.u-testim-slider').slick({
    infinite: true,
    speed: 400,
    autoplay: false,
    slidesToShow: 3,
    pauseOnHover: false,
    slidesToScroll: 3,
    arrows: false,
    centerMode: true,
    centerPadding: '0px',
    adaptiveHeight: true,
    autoplaySpeed: 5000,
    dots: true,
    responsive: [ 
      {
        breakpoint: 991,
        settings: {
         centerMode: false,
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },      
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false
        }
      }
    ]
  });
}